module.exports = __webpack_public_path__ + "static/media/sf_3000.b5e09bc1ea37a9997ad2cf7ff2213df9.png";